import { cookieService } from "@/lib/cookie/cookieService";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export type ConsentStatus = "granted" | "denied";
export const COOKIE_CONSENT_KEY = "cookie_consent";

const getCookieDomain = () => {
  if (typeof window === "undefined") return undefined;
  const hostname = window.location.hostname;
  if (hostname.endsWith(".dev.togetherwork.vn")) {
    return ".dev.togetherwork.vn";
  }
  return undefined;
};

export function getConsentCookie(): ConsentStatus | null {
  if (typeof window === "undefined") return null;
  const val = cookieService.get(COOKIE_CONSENT_KEY, { encrypt: false });
  if (val === "granted" || val === "denied") {
    return val;
  }
  return null;
}

export function setConsentCookie(status: ConsentStatus): void {
  if (typeof window === "undefined") return;
  cookieService.set(COOKIE_CONSENT_KEY, status, {
    expires: 365,
    domain: getCookieDomain(),
    encrypt: false,
  });
}

export function hasAnalyticsConsent(): boolean {
  return getConsentCookie() === "granted";
}

export function applyConsent(granted: boolean): void {
  const status: ConsentStatus = granted ? "granted" : "denied";

  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: status,
        ad_storage: status,
        ad_user_data: status,
        ad_personalization: status,
      });
    } else {
      window.dataLayer.push([
        "consent",
        "update",
        {
          analytics_storage: status,
          ad_storage: status,
          ad_user_data: status,
          ad_personalization: status,
        },
      ]);
    }
  }

  setConsentCookie(status);
}
